import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useMutation } from "urql";

import { Directory } from "../../../components/graphql/schema.graphql";
import { useUrqlResponseHandler } from "../../../hooks";
import { UpdateDirectory } from "../queries.graphql";

type DriveRenameDirectoryDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  directory: Pick<Directory, "id" | "name">;
  refreshView: () => void;
};

export default function DriveRenameDirectoryDialog({
  isOpen,
  onClose,
  directory,
  refreshView,
}: DriveRenameDirectoryDialogProps) {
  const [newDirectoryName, setNewDirectoryName] = useState("");
  const { getResponseFromState } = useUrqlResponseHandler();
  const [, updateDirectory] = useMutation(UpdateDirectory);

  useEffect(() => {
    setNewDirectoryName(directory?.name || "");
  }, [directory?.name]);

  const handleDialogClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    void updateDirectory({
      updateDirectoryInput: {
        directoryId: directory.id,
        name: newDirectoryName,
      },
    }).then((result) => {
      const { error } = getResponseFromState({
        state: result,
        errorMessage: "Failed to rename directory",
      });
      if (!error) {
        onClose();
        setNewDirectoryName("");
        refreshView();
      }
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "400px",
          },
        },
      }}
    >
      <DialogTitle>Rename Directory</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Directory Name"
          type="text"
          value={newDirectoryName}
          onChange={(event) => setNewDirectoryName(event.target.value)}
          onKeyDown={(event) => {
            switch (event.key) {
              case "Enter":
                handleSubmit();
                break;
              case "Escape":
                handleDialogClose();
                break;
            }
          }}
          fullWidth
          variant="standard"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose} variant="contained">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          Rename
        </Button>
      </DialogActions>
    </Dialog>
  );
}
